import styled from '@emotion/styled';

const SectionTitle = styled.h2`
    font: ${(props) => props.theme.fonts.heading4};
`;

export default SectionTitle;
